/**
 * SupportCreator Component
 * Temporarily disabled for AdSense review
 * Will be re-enabled after approval
 */

export function SupportCreator() {
  return null;
}
